/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayMessageDeleteBody
 */
export interface DiscordRelayMessageDeleteBody {
    /**
     * ID of the deleted message
     * @type {string}
     * @memberof DiscordRelayMessageDeleteBody
     */
    messageId: string;
    /**
     * Channel where message was deleted
     * @type {string}
     * @memberof DiscordRelayMessageDeleteBody
     */
    channelId: string;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof DiscordRelayMessageDeleteBody
     */
    botToken: string;
}

/**
 * Check if a given object implements the DiscordRelayMessageDeleteBody interface.
 */
export function instanceOfDiscordRelayMessageDeleteBody(value: object): value is DiscordRelayMessageDeleteBody {
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    return true;
}

export function DiscordRelayMessageDeleteBodyFromJSON(json: any): DiscordRelayMessageDeleteBody {
    return DiscordRelayMessageDeleteBodyFromJSONTyped(json, false);
}

export function DiscordRelayMessageDeleteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageDeleteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'channelId': json['channelId'],
        'botToken': json['botToken'],
    };
}

export function DiscordRelayMessageDeleteBodyToJSON(json: any): DiscordRelayMessageDeleteBody {
    return DiscordRelayMessageDeleteBodyToJSONTyped(json, false);
}

export function DiscordRelayMessageDeleteBodyToJSONTyped(value?: DiscordRelayMessageDeleteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messageId': value['messageId'],
        'channelId': value['channelId'],
        'botToken': value['botToken'],
    };
}

